import React, { useState, useRef, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import StrixhavenSchool from "../../components/playerprofiles/StrixhavenSchool";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import WrapperViewer from "../../components/layout/WrapperViewer";
import DebugOverlay from "../../components/widgets/DebugOverlay";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function CustomLeaderboardPreview({
   currentPage,
   activeData,
   show,
   runTimestamp,
   preview,
}) {

   const strixhavenSchoolTeamAggregate =
      Boolean(
         activeData &&
            activeData.rows &&
            activeData.rows.length > 0 &&
            activeData.rows[0].Team &&
            !activeData.rows[0].PlayerName &&
            (activeData.Title === "STRIXHAVEN SCHOOLS" ||
               (activeData.key &&
                  String(activeData.key).startsWith("STRIXHAVEN-SCHOOLS-")))
      );

   return (
      <WrapperViewer>
         <Box
            sx={{
               position: "absolute",
               top: 40,
               right: 100,
               height: 200,
            }}
         >
            <img src={SERVER_URL + "/images/ui/logo-800.png"} width='140' />
         </Box>

         <AnimatePresence>
            {show && activeData && (
               <Stack
                  sx={{
                     position: "absolute",
                     top: 40,
                     left: 100,
                     height: 200,
                  }}
                  justifyContent='center'
                  key={activeData.key + "-title"}
                  component={motion.div}
                  initial={{ opacity: 0, scale: 1.1 }}
                  animate={{
                     opacity: 1,
                     scale: 1,
                  }}
                  exit={{
                     scale: 1.1,
                     opacity: 0,
                  }}
                  transition={{
                     easing: "easeOut",
                     duration: preview ? 0 : 0.4,
                  }}
               >
                  <Typography
                     variant='h1Viewer'
                     component='div'
                     sx={{ textTransform: "uppercase" }}
                  >
                     {activeData && activeData.Title && activeData.Title.includes('Strixhaven') ? (
                        <>
                        <Typography variant='h2Viewer' component='div' sx={{ textTransform: "uppercase" }}>Strixhaven School</Typography>
                        <StrixhavenSchool school={activeData.Title.split(' — ')[1]} iconWidth={64} direction='row' spacing={4} />
                        </>
                     ) : (
                        activeData && activeData.Title
                     )}
                
                  </Typography>

                  {activeData && activeData.showSubtitle !== false && (
                     (activeData.customSubtitle && activeData.customSubtitle.trim() !== "") ? (
                        <Typography
                           variant='h2Viewer'
                           component='div'
                           sx={{ 
                              textTransform: "uppercase",
                              color: "#ff9800"
                           }}
                        >
                           {activeData.customSubtitle}
                        </Typography>
                     ) : Boolean(
                        ((activeData && activeData.StandingsId && Number(activeData.StandingsId) > 0) ||
                           (activeData && activeData.Round && activeData.showRoundInOrange)) &&
                        Number(activeData.StandingsId) !== 0 &&
                        !["quarterfinals", "semifinals", "finals"].includes(
                           (activeData.Round || "").toLowerCase()
                        )
                     ) && (
                        <Typography
                           variant='h2Viewer'
                           component='div'
                           sx={{ 
                              textTransform: "uppercase",
                              color: "#ff9800"
                           }}
                        >
                           {activeData.Round || "Round"}
                        </Typography>
                     )
                  )}
               </Stack>
            )}
         </AnimatePresence>

         <AnimatePresence>
            {show &&
               activeData &&
               activeData.rows &&
               activeData.rows.length > 0 && (
                  <Stack
                     direction='row'
                     alignItems='flex-start'
                     spacing={3}
                     sx={{
                        position: "absolute",
                        width: 1720,
                        top: activeData.Rows > 9 ? 240 : 260,
                        left: 100,
                     }}
                     key={activeData.key + "-p" + currentPage}
                     component={motion.div}
                     initial={{ opacity: 0, x: 100 }}
                     animate={{
                        opacity: 1,
                        x: 0,
                        transition: { delay: 0.2 },
                     }}
                     exit={{
                        x: -100,
                        opacity: 0,
                     }}
                     transition={{
                        easing: "easeOut",
                        duration: preview ? 0 : 0.3,
                     }}
                  >
                     {_.range(activeData.Columns).map((renderCol) => (
                        <Table key={`table-col-${renderCol}`} variant='standings'>
                           <TableHead>
                              <TableRow>
                                 {activeData.rows[0].Rank && (
                                    <TableCell
                                       width={
                                          activeData.rows[0].Rank != 0
                                             ? "10%"
                                             : "2%"
                                       }
                                       sx={{ textAlign: "center" }}
                                    >
                                       {activeData.rows[0].Rank != 0
                                          ? "RANK"
                                          : ""}
                                    </TableCell>
                                 )}
                                 <TableCell
                                    sx={{
                                       pl: !activeData.rows[0].Rank ? 10 : 0,
                                       ...(activeData.rows[0]?.Team &&
                                       !activeData.rows[0]?.PlayerName &&
                                       strixhavenSchoolTeamAggregate
                                          ? { textAlign: "left" }
                                          : {}),
                                    }}
                                 >
                                    {activeData.rows[0] && activeData.rows[0].Team && !activeData.rows[0].PlayerName
                                       ? strixhavenSchoolTeamAggregate
                                          ? "SCHOOL"
                                          : "TEAM"
                                       : "NAME"}
                                 </TableCell>
                                 {(activeData.Archetype === 1 || activeData.Archetype === 2 || activeData.Archetype === 3) && (
                                       <TableCell
                                          width='28%'
                                          sx={{ textAlign: "center" }}
                                       >
                                          {activeData.Archetype === 1
                                             ? "ARCHETYPE"
                                             : activeData.Archetype === 3
                                                ? "SCHOOL"
                                                : strixhavenSchoolTeamAggregate
                                                   ? "SCHOOL"
                                                   : "TEAM"}
                                       </TableCell>
                                    )}
                                 {activeData.rows[0] && (
                                    (activeData.rows[0].MatchWins !== undefined || activeData.rows[0].MatchWins === 0) ||
                                    (activeData.rows[0].Win !== undefined || activeData.rows[0].Win === 0)
                                 ) && (
                                    <>
                                       <TableCell
                                          width='6%'
                                          sx={{ textAlign: "center" }}
                                       >
                                          WIN
                                       </TableCell>
                                       <TableCell
                                          width='6%'
                                          sx={{ textAlign: "center" }}
                                       >
                                          LOSS
                                       </TableCell>
                                       <TableCell
                                          width='6%'
                                          sx={{ textAlign: "center" }}
                                       >
                                          DRAW
                                       </TableCell>
                                       {activeData.rows[0] && activeData.rows[0].Team && !activeData.rows[0].PlayerName && (
                                          <TableCell
                                             width='6%'
                                             sx={{ textAlign: "center" }}
                                          >
                                             WIN PCT
                                          </TableCell>
                                       )}
                                    </>
                                 )}
                              </TableRow>
                           </TableHead>
                           <TableBody>
                              {activeData.rows
                                 .slice(
                                    activeData.Columns *
                                       currentPage *
                                       activeData.Rows +
                                       renderCol * activeData.Rows,
                                    activeData.Columns *
                                       currentPage *
                                       activeData.Rows +
                                       activeData.Rows +
                                       renderCol * activeData.Rows
                                 )
                                 .map((row, i) => (
                                    <React.Fragment
                                       key={"column-" + renderCol + "-" + i}
                                    >
                                       <TableRow>
                                          {activeData.rows[0].Rank && (
                                             <TableCell
                                                sx={{ textAlign: "center" }}
                                             >
                                                {activeData.rows[0].Rank != 0
                                                   ? row.Rank
                                                   : ""}
                                             </TableCell>
                                          )}
                                          <TableCell
                                             sx={{
                                                width: activeData.rows[0].FormatDecklistName
                                                   ? "auto"
                                                   : "40%",
                                                position: "relative",
                                                overflow: "hidden",
                                                pl: !activeData.rows[0].Rank
                                                   ? 10
                                                   : 0,
                                                ...(strixhavenSchoolTeamAggregate
                                                   ? { textAlign: "left" }
                                                   : {}),
                                             }}
                                          >
                                             <Box
                                                className={row.HOF == 1 ? 'fadeAwayHof' : "fadeAway"}
                                                sx={{
                                                   position: "absolute",
                                                   top: 0,
                                                   right: -2,
                                                   width: "100%",
                                                   height: "100%",
                                                   zIndex: 100,
                                                }}
                                             />
                                             <Stack
                                                direction='row'
                                                spacing={2}
                                                justifyContent='space-between'
                                                sx={{
                                                   position: "relative",
                                                   textTransform:
                                                      row.Team &&
                                                      !row.PlayerName &&
                                                      strixhavenSchoolTeamAggregate
                                                         ? "none"
                                                         : "uppercase",
                                                }}
                                             >
                                                {!(row.Team && !row.PlayerName) && (
                                                   <Box
                                                      sx={{
                                                         width: 50,
                                                         height: 32,
                                                         fontSize: 10,
                                                         textAlign: "center",
                                                      }}
                                                   >
                                                      {row.CountryFlag && (
                                                         <Box
                                                            sx={{
                                                               width: "100%",
                                                               height: "100%",
                                                               background:
                                                                  "url(" +
                                                                  row.CountryFlag +
                                                                  ") center center",
                                                               backgroundSize:
                                                                  "contain",
                                                               backgroundRepeat:
                                                                  "no-repeat",
                                                            }}
                                                         />
                                                      )}
                                                      {!row.CountryFlag && (
                                                         <>{row.Country}</>
                                                      )}
                                                   </Box>
                                                )}
                                                <Box
                                                   sx={{
                                                      position: "absolute",
                                                      left: row.Team && !row.PlayerName ? 0 : 50,
                                                      width: "100%",
                                                      whiteSpace:
                                                         row.Team &&
                                                         !row.PlayerName &&
                                                         strixhavenSchoolTeamAggregate
                                                            ? "normal"
                                                            : "nowrap",
                                                      top:
                                                         row.Team &&
                                                         !row.PlayerName &&
                                                         strixhavenSchoolTeamAggregate
                                                            ? 0
                                                            : "50%",
                                                      transform:
                                                         row.Team &&
                                                         !row.PlayerName &&
                                                         strixhavenSchoolTeamAggregate
                                                            ? "none"
                                                            : "translateY(-50%)",
                                                   }}
                                                >
                                                   {row.Team && !row.PlayerName ? (
                                                      strixhavenSchoolTeamAggregate ? (
                                                         <StrixhavenSchool
                                                            school={row.Team}
                                                            iconWidth={30}
                                                            sx={{ marginTop: "-20px" }}
                                                            direction='row'
                                                            spacing={2}
                                                            align='flex-start'
                                                         />
                                                      ) : (
                                                         <span>{row.Team}</span>
                                                      )
                                                   ) : (
                                                      <span>{row.PlayerName}</span>
                                                   )}
                                                </Box>
                                                {row.HOF == 1 && (
                                                   <Box
                                                      sx={{
                                                         height: "100%",
                                                         width: 60,
                                                         position: "absolute",
                                                         right: 5,
                                                         zIndex: 100
                                                      }}
                                                   >
                                                      <img
                                                         src={
                                                            SERVER_URL +
                                                            "/images/icons/hof.png"
                                                         }
                                                         style={{
                                                            width: 60,
                                                            position:
                                                               "absolute",
                                                            top: "50%",
                                                            transform:
                                                               "translateY(-50%)",
                                                         }}
                                                      />
                                                   </Box>
                                                )}
                                             </Stack>
                                          </TableCell>
                                          {(activeData.Archetype === 1 || activeData.Archetype === 2 || activeData.Archetype === 3) && (
                                                <TableCell
                                                   sx={{ textAlign: "center" }}
                                                >
                                                   {activeData.Archetype === 1 ? (
                                                      row.FormatDecklistName || ""
                                                   ) : activeData.Archetype === 3 ? (
                                                      <Stack
                                                         alignItems='center'
                                                         justifyContent='center'
                                                         sx={{ width: "100%" }}
                                                      >
                                                         <StrixhavenSchool
                                                            school={row.STRIXHAVEN_SCHOOL || ""}
                                                            iconWidth={44}
                                                            direction='row'
                                                            spacing={4}
                                                            align='center'
                                                         />
                                                      </Stack>
                                                   ) : strixhavenSchoolTeamAggregate ? (
                                                      <Stack
                                                         alignItems='center'
                                                         justifyContent='center'
                                                         sx={{ width: "100%" }}
                                                      >
                                                         <StrixhavenSchool
                                                            school={row.Team || row.TEAM || ""}
                                                            iconWidth={44}
                                                            direction='row'
                                                            spacing={1}
                                                            align='center'
                                                         />
                                                      </Stack>
                                                   ) : (
                                                      row.TEAM || ""
                                                   )}
                                                </TableCell>
                                             )}
                                          {activeData.rows[0] && (
                                             (activeData.rows[0].MatchWins !== undefined || activeData.rows[0].MatchWins === 0) ||
                                             (activeData.rows[0].Win !== undefined || activeData.rows[0].Win === 0)
                                          ) && (
                                             <>
                                                <TableCell
                                                   sx={{ textAlign: "center" }}
                                                >
                                                   {row.Team && !row.PlayerName ? (row.Win !== undefined ? row.Win : 0) : (row.MatchWins !== undefined ? row.MatchWins : 0)}
                                                </TableCell>
                                                <TableCell
                                                   sx={{ textAlign: "center" }}
                                                >
                                                   {row.Team && !row.PlayerName ? (row.Loss !== undefined ? row.Loss : 0) : (row.MatchLosses !== undefined ? row.MatchLosses : 0)}
                                                </TableCell>
                                                <TableCell
                                                   sx={{ textAlign: "center" }}
                                                >
                                                   {row.Team && !row.PlayerName ? (row.Draw !== undefined ? row.Draw : 0) : (row.MatchDraws !== undefined ? row.MatchDraws : 0)}
                                                </TableCell>
                                                {row.Team && !row.PlayerName && (
                                                   <TableCell
                                                      sx={{ textAlign: "center" }}
                                                   >
                                                      {row.WinPercent !== undefined ? row.WinPercent.toFixed(1) + '%' : '0.0%'}
                                                   </TableCell>
                                                )}
                                             </>
                                          )}
                                       </TableRow>
                                    </React.Fragment>
                                 ))}
                           </TableBody>
                        </Table>
                     ))}
                  </Stack>
               )}
         </AnimatePresence>
      </WrapperViewer>
   );
}
